<script setup>
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
import Responsive from '@/services/browser/Responsive';
import Footer from '@/components/microsites/Footer.vue';
import Accordian from '@/components/microsites/Accordian.vue';
import { useNavTo, useNavMenu } from '@/components/microsites/NavScroll'
import '@/assets/scss/microsites/msf/_msf.scss';
import Cookie from '@/services/browser/Cookie';
import axios from 'axios'
import { ObserveVisibility as vObserveVisibility } from 'vue-observe-visibility'

const navItems = [
  {
    key: 'hero',
    name: 'MapleStory Fest 2023'
  },
  {
    key: 'ticket',
    name: 'Tickets'
  },
  {
    key: 'activity',
    name: 'Activities'
  },
  {
    key: 'venue',
    name: 'Venue'
  },
  {
    key: 'faq',
    name: 'FAQ'
  },
  {
    key: 'history',
    name: 'History'
  },
];
const slides = [
  'November 12, 2022: MapleStory Fest returned to Los Angeles in person  with the special announcement of MapleStory Worlds, first-look at new additions for MapleStory and MapleStory M, and the exciting finale of the Boss Blitz competition!',
  `November 13, 2021: MapleStory Fest At Home returned for another year full of fun online games and special reveals, including Pathfinder coming to MapleStory M, Lara's debut for MapleStory, and more!`,
  `November 11, 2020: The first MapleStory Fest At Home was an entirely online affair, with streamed 
appearances by the MapleStory team, Bean Brigade members, and more as we celebrated MapleStory from the comfort and safety of our homes!`,
  `May 11, 2019: Our second MapleStory Fest featured the debut of Pathfinder on the 14th anniversary of MapleStory's launch in North America, including a special appearance by Pathfinder's voice actor, Sarah Anne Williams!`,
  `April 14, 2018: Our very first MapleStory Fest! Our first face-to-face meeting with Maplers saw the reveal of Ark for MapleStory, and the launch date announcement for MapleStory M!`
];
const activeSlide = ref(0);
const faqs = ref([]);
function changeSlide(index){
  if( index < 0 ){
    index = slides.length-1;
  }
  if( index >= slides.length ){
    index = 0;
  }
  clickTracking({
    interaction: 'carousel_click',
    sectionNumber: 5,
    sectionName: 'History',
    sectionContent: `Image${index+1}`,
  })
  activeSlide.value = index;
}
const fireworksHero1Visibility = ref(false);
const fireworksHero2Visibility = ref(false);
const fireworksHero3Visibility = ref(false);

const fireworksBody1Visibility = ref(false);
const fireworksBody2Visibility = ref(false);

// const navScroll = (e) => {
//   let navHeight = document.querySelector(".m-msf-nav").offsetHeight;
//   navHeight = navHeight * 0.8;
//   useNavTo(e, navHeight)
// }
const fireworkDelay = ( element, delayvalue) => {
  setTimeout(()=>{
    element.value = true;
  },delayvalue)
}
const viewTracking = ( { id, name } ) => {
  window.dataLayer.push({
    'event': 'standardMicrositeTrackingEvent',
    'interaction': 'section_view',
    'micrositeSectionNumber': id,
    'micrositeSectionName': name,
  });
}
const clickTracking = ({ interaction, sectionNumber, sectionName, sectionContent, specialValue }) => {
  window.dataLayer.push({
    event: 'standardMicrositeTrackingEvent',
    interaction: interaction,
    micrositeSectionNumber: sectionNumber,
    micrositeSectionName: sectionName,
    micrositeSectionContent: sectionContent,
    ...(specialValue ? { micrositeSpecialValue: specialValue } : {}),
  });
}
const observeVisibilitySettings = (id, name, threshold = 0.3) => {
  return {
    callback: (isVisible) => isVisible ? viewTracking({ id, name }) : null,
    intersection: { threshold: threshold },
    throttle: 1000,
    once: true,
  }
}
const faqTracking = (index) => {
  clickTracking({
    event: 'standardMicrositeTrackingEvent',
    interaction: 'content_view',
    sectionNumber: 4,
    sectionName: 'FAQ',
    sectionContent: `FAQ${index+1}`,
  })
}
// lifecycle hooks
onMounted( async () => {

  window.dataLayer.push({
    'pageType':       'Microsite',
    'micrositeName':  'MapleStory Fest 2023',
    'micrositePhase': '1'
  });

  Responsive.init( {
  debounce: 200,
  views: [
      {
        view: 'mobile',
        windowWidth: 600,
        fontSize: 22.3,
        minFontSize: 1
      },
      {
        view: 'tablet',
        windowWidth: 1024,
        fontSize: 38,
        minFontSize: 1
      },
      {
        view: 'desktop',
        windowWidth: 1440,
        fontSize: 18,
        minFontSize: 12,
        xmaxFontSize: 23
      }
    ],
    store: store
  });
  Cookie.set("msf", "true")

  // ScrollTo & Active Navigation
  useNavTo({
    offset: 0,
    $offsetHeader: '.m-msf-nav',
    $offsetHeaderRatio: 0.8
  });
  useNavMenu();

  // Fireworks
  fireworkDelay(fireworksHero1Visibility, 200)
  fireworkDelay(fireworksHero2Visibility, 1300)
  fireworkDelay(fireworksHero3Visibility, 1500)
  fireworkDelay(fireworksBody1Visibility, 300)
  fireworkDelay(fireworksBody2Visibility, 700)

  // Faqn
  const response = await axios.get(`${process.env.VUE_APP_UMBRACO}/v1/maplestory/maplestory-fest/faqs`);
  faqs.value = response.data.map( (faqItem)=>{ 
    return { question: faqItem.question.en, answer: faqItem.answer.en }
  })
})

</script>

<template>
  <div class="m-msf">
    <div class="m-msf-nav">
      <div class="m-msf-nav__frame"></div>
      <div 
        :navTo="`section-m-msf-${navItem.key}`" v-for="(navItem, index) in navItems" 
        :key="index" 
        :class="`m-msf-nav__item m-msf-nav__item--${index+1}`"
        @click="clickTracking({
          interaction: 'menu_click',
          sectionNumber: 0,
          sectionName: 'Header',
          sectionContent: navItem.name,
        })"
      >
      </div>
    </div>
    <section class="m-msf-hero" navSection="section-m-msf-hero" v-observe-visibility="observeVisibilitySettings(0, 'Header')">
      <div class="m-msf-hero__firework1"></div>
      <div v-if="fireworksHero1Visibility" class="m-msf-hero__firework2"></div>
      <div v-if="fireworksHero2Visibility" class="m-msf-hero__firework3"></div>
      <div v-if="fireworksHero3Visibility" class="m-msf-hero__firework4"></div> 
      <h1 class="m-msf-hero__title">MapleStory Fest
        <span>
          <br/>Returns on
          <br/>October 14, 2023!
        </span>
      </h1>
      <div class="m-msf-hero__text">
        Join us at LA River Studios in Los Angeles and meet up with your fellow Maplers 
        for a day of fun dedicated to 
        all things MapleStory!
      </div>
    </section>

    <div v-if="fireworksBody1Visibility" class="m-msf-body-firework1"></div>
    <div v-if="fireworksBody2Visibility" class="m-msf-body-firework2"></div>

    <div v-if="fireworksBody1Visibility" class="m-msf-body-firework3"></div>

    <div v-if="fireworksBody1Visibility" class="m-msf-body-firework4"></div>
    <div v-if="fireworksBody2Visibility" class="m-msf-body-firework5"></div>

    <div v-if="fireworksBody1Visibility" class="m-msf-body-firework6"></div>
    <div v-if="fireworksBody2Visibility" class="m-msf-body-firework7"></div>

    <div class="m-msf-content-bg">
    </div>

    <section class="m-msf-ticket" navSection="section-m-msf-ticket" v-observe-visibility="observeVisibilitySettings(1, 'Tickets')">
      <div class="m-msf-ticket__title">
        Tickets on Sale Sept. 7!
      </div>
      <div class="m-msf-ticket__text">
        Tickets to MapleStory Fest are only <span>$30</span>, and a limited quantity releases on <span>Sept. 7 at 12:00 PM PT.</span> Last year they sold out, so don't wait!
      </div>
    </section>

    <section class="m-msf-activity" navSection="section-m-msf-activity" v-observe-visibility="observeVisibilitySettings(2, 'Activities')">
      <div class="m-msf-activity__text1">
        The fun never stops at MapleStory Fest! Hang out with other Maplers and enjoy photo ops, mini-games, contests and more. 
      </div>
      <div class="m-msf-activity__img">
      </div>
      <div class="m-msf-activity__text2">
        Can’t make it? Find us on social media to catch the latest news and video from MapleStory Fest 2023!
      </div>
    </section>

    <section class="m-msf-venue" navSection="section-m-msf-venue" v-observe-visibility="observeVisibilitySettings(3, 'Venue')">
      <div class="m-msf-venue__text1">
        MapleStory Fest 2023 is at 
        <a href="https://www.lariverstudios.com/" 
          target="_blank" 
          @go-to-main-click="clickTracking({
          interaction: 'link_click',
          sectionNumber: 3,
          sectionName: 'Venue',
          sectionContent: 'LA River Studios',
        })">LA River Studios</a>. Located in the heart of the burgeoning LA River Arts Corridor, LA River Studios is the reimagination of a vintage-era factory warehouse.
      </div>
      <!-- <div class="m-msf-venue__img"></div> -->
      <div class="m-msf-venue__map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3303.7217941576796!2d-118.23667259999998!3d34.102266799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c6cf17d3d0ed%3A0x981b7865a7da1df7!2s2800%20Division%20St%2C%20Los%20Angeles%2C%20CA%2090065!5e0!3m2!1sen!2sus!4v1692910323249!5m2!1sen!2sus" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div class="m-msf-venue__text2">
        LA River Studios is located at <span>2800 Division St, Los Angeles, CA, 90065</span>, just off North San Fernando Road between the 2 and 110 Freeways. Parking can be found at Sotomayor Magnet School across the street from the venue.
      </div>
    </section>

    <section class="m-msf-faq" navSection="section-m-msf-faq" v-observe-visibility="observeVisibilitySettings(4, 'FAQ')">
      <div class="m-msf-faq__title">
        Frequently Asked Questions
      </div>
      <div class="m-msf-faq-accordian-wrapper">
        <Accordian :items="faqs" :cbAfterOpen="faqTracking"  class="m-msf-faq-accordian" :currentView="store.state.storeMicrosites.sizeView"/>
      </div>
    </section>

    <section class="m-msf-theather" navSection="section-m-msf-history" v-observe-visibility="observeVisibilitySettings(5, 'History')">
      <div class="m-msf-theather-slide">
        <div 
          class="m-msf-theather-slide__img" 
          :class="`m-msf-theather-slide__img--${activeSlide}`">
        </div>
        <div class="m-msf-theather-slide__arrow m-msf-theather-slide__arrow-left" @click="changeSlide( activeSlide - 1)"></div>
        <div class="m-msf-theather-slide__arrow m-msf-theather-slide__arrow-right" @click="changeSlide(  activeSlide + 1)"></div>
        <div class="m-msf-theather-slide__dots">
          <div 
            v-for="(slide, index) in slides"
            :key="index"
            class="m-msf-theather-slide__dot"
            :class="{active: activeSlide == index }"
            @click="changeSlide(index)"
          >
          </div>
        </div>
        <div class="m-msf-theather-slide__text">
          {{ slides[activeSlide] }}
      </div>
      </div>
    </section>

    <Footer
      color="#f87050"
      hoverColor="#ffffff"
      backgroundColor="#251c35"
      @go-to-main-click="clickTracking({
        interaction: 'link_click',
        sectionNumber: 6,
        sectionName: 'Footer',
        sectionContent: 'Main Site',
      })"
      @link-click="(name) => clickTracking({
        interaction: 'link_click',
        sectionNumber: 6,
        sectionName: 'Footer',
        sectionContent: name,
      })"
    />
  </div>
</template>

<style scoped lang="scss">
  :deep() {
    .accordion__item {
      padding-bottom: 0.7rem;
      margin-bottom: 0.6rem;
      border-bottom: 2px solid #c1ab8d;
    }
    .accordion__header {
      font-size: 1rem; line-height: 1.2rem;
      color: #673c26;
    }
    .accordion__content {
      font-size: 1rem; line-height: 1.3rem;
      padding-top: 0.7rem;
      color: #a77f07;
    }
    .accordion__arrow{
      width: 1.5rem; height: 1.5rem;
    background: url('~@/assets/images/microsites/msf/faq/arrow.png')  no-repeat center top / 100% auto;
    }
    &.opened {
      background: url('~@/assets/images/microsites/msf/faq/arrow-opened.png')  no-repeat center top / 100% auto;
    }

    .mobile, .tablet{ 
      .accordion__header {
        font-size: 0.64rem; line-height: 1rem;
      }
      .accordion__item {
        padding-bottom: 0.5rem;
        margin-bottom: 0.42rem;
      }
      .accordion__arrow {
        width: 1.3rem; height: 1.3rem;
      }
      .accordion__content {
        font-size: 0.7rem; line-height: 1rem;
        p {
          padding-top: 0;
          margin-top: 0;
        }
      }
    }
  }
</style>